import { cx } from '@emotion/css';
import { useMediaQuery } from '@sortlist-frontend/design-system/legacy';
import { useTranslation } from '@sortlist-frontend/translation/ssr';

import { BriefingButton } from '_components/Briefing/versions/NormalBriefing/button';
import { usePublicAppContext } from '_core/context/public-app-context';
import { homeConfig } from '_features/home/home.config';

export const SortlistForYourNeed = () => {
  const { t } = useTranslation(homeConfig.i18nNamespaces);
  const { getUrl } = usePublicAppContext();
  const { media_legacy } = useMediaQuery();

  return (
    <section className="py-8 sm:py-16">
      <div className="container-lg px-0 sm:px-4">
        <div
          className={cx(
            { 'rounded-xl': media_legacy.gtXs },
            'py-24 bg-secondary-900 layout-align-start-stretch layout-align-gt-xs-center-center layout-column text-gt-xs-center px-8',
          )}>
          <p className={cx(media_legacy.gtXs ? 'text-center' : 'text-left', 'h1 bold mb-2 text-secondary-100')}>
            {t('home:sections.SortlistForYourNeed.title')}
          </p>
          <p className={cx(media_legacy.gtXs ? 'text-center' : 'text-left', 'h6 mb-8 text-secondary-300')}>
            {t('home:sections.SortlistForYourNeed.subTitle_V2')}
          </p>
          <div className="layout-column layout-gt-xs-row layout-align-start-stretch layout-align-gt-xs-center-center">
            <BriefingButton
              cta={'next-need'}
              size="lg"
              className="medium"
              buttonStyle="secondary"
              buttonVariant="flat"
              label={t('common:navbar.findAgencies.postAProject.title')}
            />
            {<span className="m-4 text-secondary-500 hide-xs">{t('common:general.or')}</span>}
            <button
              className="btn-md rounded-lg medium btn-outlined p-4 max-sm:mt-4 text-neutral-100 bg-secondary-900 border-neutral-100 border btn-outlined"
              data-testid="search-for-agencies"
              onClick={() => (window.location.href = getUrl('client.explore'))}>
              {t('home:sections.header.searchButton_V2')}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};
